module.exports = __webpack_public_path__ + "static/notification-1x-abc0a48c8e0957a8cac5084e52f28097.png";